import Typography from "@/components/Typography";
import { cx } from "@/utils";

import styles from "./Label.module.css";

type LabelProps = {
  content?: React.ReactNode;
  block?: boolean;
  children?: React.ReactNode;
  className?: string;
};

const Label: React.FunctionComponent<LabelProps> = ({
  children,
  content,
  block,
  className,
  ...rest
}) => {
  return (
    <Typography
      variant="body-2"
      component="label"
      className={cx(styles.root, { [styles.block]: block }, className)}
      {...rest}
    >
      {content}
      {children}
    </Typography>
  );
};

export default Label;
